import { useMemo } from 'react';

import {
  type ParsedSection,
  parseMarkdownH2Sections,
  type SectionFormat,
} from '../utils/markdown-utils';

interface UseJotdocSectionsResult {
  sections: ParsedSection[];
  sectionMap: Map<string, ParsedSection>;
  format: SectionFormat;
}

export function useJotdocSections(content?: string | null): UseJotdocSectionsResult {
  const sections = useMemo(() => parseMarkdownH2Sections(content ?? ''), [content]);

  const sectionMap = useMemo(
    () => new Map(sections.map(section => [section.id, section])),
    [sections],
  );

  const format: SectionFormat =
    sections.length > 0 && sections.every(section => section.format === 'xml')
      ? 'xml'
      : 'markdown';

  return {
    sections,
    sectionMap,
    format,
  };
}


